(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["availability-form"] && !Shopify.designMode) return;
  try {
    
  const params = new URLSearchParams(document.location.search);
  const productHandle = params.get('product');
  const variantId = params.get('variant');

  const productInput = document.querySelector('#availability__product');
  const sizeDropdown = document.querySelector('.size__selector');
  const sizeInput = sizeDropdown?.querySelector('#availability__size');
  const sizeButton = sizeDropdown?.querySelector('.dropdown__button-text');
  const sizeList = sizeDropdown?.querySelector('#size-selector__list');

  async function getProductDetails() {
    if (!productHandle) return;

    try {
      const res = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);

      if (!res.ok) {
        throw new Error('Failed to fetch product data');
      }

      const product = await res.json();

      if (productInput) {
        productInput.value = product.title;
        productInput.classList.add('disabled');
      }

      if (sizeDropdown) {
        const selectedVariant = variantId
          ? product.variants.find((variant) => variant.id == variantId)
          : product.variants[0];

        const options = product.variants.map((variant) => {
          const li = document.createElement('li');
          li.classList.add('dropdown__item');
          li.tabIndex = -1;

          const a = document.createElement('a');
          a.href = '#';
          a.dataset.value = variant.title;
          a.textContent = variant.title;

          li.appendChild(a);

          return li;
        });

        const fragment = document.createDocumentFragment();
        for (const option of options) {
          fragment.appendChild(option);
        }

        sizeButton.textContent = selectedVariant.title;
        sizeInput.value = selectedVariant.title;
        sizeList.replaceChildren(fragment);
      }
    } catch (error) {
      throw new Error(error);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    getProductDetails();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  const cartDrawer = document.getElementById('cart-drawer');

  document.addEventListener('DOMContentLoaded', () => {
    cartDrawer.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const menuToggle = document.querySelector('.header__nav-toggle');
  const menu = document.querySelector('.header__nav');

  menuToggle.addEventListener('click', () => {
    menu.classList.toggle('open');
  });

  document.addEventListener('click', (e) => {
    if (!menu.contains(e.target) && !menuToggle.contains(e.target)) {
      menu.classList.remove('open');
    }
  });

  const dialog = document.querySelector('.localisation-modal');
  const languageToggle = document.querySelector('.header__language-toggle');

  languageToggle.addEventListener('click', () => {
    if (dialog.open) {
      dialog.close();
    } else {
      dialog.show();
    }
  });

  const closeNav = document.querySelector('.header__close-nav');

  closeNav.addEventListener('click', () => {
    menu.classList.remove('open');
  });

  const cartDrawer = document.getElementById('cart-drawer');
  const cartLink = document.querySelector('.header__cart-link');

  cartLink.addEventListener('click', () => {
    cartDrawer.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
